import { createAction } from "@reduxjs/toolkit"

import { USER_SLICE_NAME } from "./user.constants"

// Plain actions shared between user.thunks.js (dispatches them mid-flow, mirroring what
// the legacy saga did with `yield put(UserActions.x(...))`) and user.slice.js (reacts to
// them via `extraReducers`). Kept in their own file so neither of those two files needs
// to import the other — the slice already imports the thunks for their `pending` cases,
// so the reverse edge would be a circular dependency.
export const userSetProp = createAction(`${USER_SLICE_NAME}/userSetProp`)
export const changeNextCreateAccountStep = createAction(
  `${USER_SLICE_NAME}/changeNextCreateAccountStep`
)
export const setDemoTourStep = createAction(`${USER_SLICE_NAME}/setDemoTourStep`)

// `attachPaymentSuccess` is both the fulfilled state of the `attachPayment` thunk and a
// standalone action the `createBillingDescriptor` thunk fires when onboarding finishes
// without a payment step — exactly as the legacy saga did.
export const attachPaymentSuccess = createAction(`${USER_SLICE_NAME}/attachPaymentSuccess`)

// `createBillingDescriptor` dispatches its own success instead of relying on `fulfilled`:
// its success reducer bumps `nextCreateAccountStep`, and the thunk's follow-up branches
// read and then clear that same field, so the reducer has to run first.
export const createBillingDescriptorSuccess = createAction(
  `${USER_SLICE_NAME}/createBillingDescriptorSuccess`
)
